import { action } from 'satcheljs/lib/legacy';
import { getSurfaceStore } from '../store/surfaceStore';

/**
 * Action to update the cached charms
 * Implement store for charms and remove this action
 */
export let updateCachedCharms = action('updateCachedCharms')(function updateCachedCharms(
    charmId: number,
    calendarFolderId: string
) {
    getSurfaceStore()
        .calendarItems.filter(item => item.ParentFolderId.Id === calendarFolderId)
        .forEach(calendarItem => {
            // Trigger re-render on all affected items
            let s = calendarItem.ItemId.Id;
            calendarItem.ItemId.Id = '';
            calendarItem.ItemId.Id = s;
        });
});

export default updateCachedCharms;
